import { useMemo } from 'react';
import { readConversationSortKeys, } from 'apis/conversations';
import { toBoolean } from 'utils/formatting/string';
import { getSortObjectFromString } from 'utils/url/getSortObjectFromString';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';
import { getEnrichedConversationStatus } from './utils/getEnrichedConversationStatus';
/** The default conversations page limit. */
const defaultPageLimit = 50;
/**
 * A hook that takes search params of the conversations page and converts it to
 * the api arg that can be used when consuming various conversations api related
 * endpoints.
 */
export const useConversationsParamsToApiArg = () => {
    const { params } = useAppSearchParams('/conversations');
    const enrichedStatus = useMemo(() => {
        if (!params.status) {
            return undefined;
        }
        const statusParam = (params.status instanceof Array ? [...params.status] : [params.status]).filter(Boolean);
        return getEnrichedConversationStatus(statusParam);
    }, [params.status]);
    // The conversations and paginated api arg whenever params get updated.
    return useMemo(() => {
        const status = enrichedStatus;
        const paramsConversationsApiArg = {
            agentIds: params.assigned ? toBoolean(params.assigned) : params.agent,
            channels: params.channel,
            directions: params.direction,
            queueIds: params.queue,
            requesterIds: params.requester,
            status,
        };
        const paramsPaginatedApiArg = {
            limit: params.limit ? parseInt(params.limit) : defaultPageLimit,
            offset: params.offset ? parseInt(params.offset) : undefined,
        };
        const paramsSortedApiArg = {
            sort: params.sort
                ? getSortObjectFromString(params.sort, readConversationSortKeys)
                : undefined,
        };
        return {
            paramsConversationsApiArg,
            paramsPaginatedApiArg,
            paramsSortedApiArg,
        };
    }, [
        params.assigned,
        params.agent,
        params.channel,
        params.direction,
        params.queue,
        params.requester,
        params.limit,
        params.offset,
        params.sort,
        enrichedStatus,
    ]);
};
